import Header from "@/components/Header/Header.vue"

export default {
    name: 'Employee',
    components: {
        Header,
    },
}
